import { render, staticRenderFns } from "./HomeItem.vue?vue&type=template&id=7bf1f45c&"
import script from "./HomeItem.vue?vue&type=script&lang=js&"
export * from "./HomeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports